import Swiper from 'swiper';
// eslint-disable-next-line import/no-unresolved -- This works but build tools doesn't recognize it
import { Navigation } from 'swiper/modules';

const body = document.querySelector('body');
const screenshotsSliderElement = document.querySelector('.single-game__screenshots .swiper');
const lightboxElement = document.querySelector('.single-game__screenshots .lightbox');
const relatedGamesSliderElement = document.querySelector('.single-game__related-games .swiper');
const relatedCategoriesSliderElement = document.querySelector(
  '.single-game__related-categories .swiper',
);

/**
 * Close the lightbox and pause all videos
 */
function closeLightbox() {
  body.classList.remove('lightbox-open');
  lightboxElement.querySelectorAll('video').forEach((video) => {
    video.pause();
  });
}

/**
 * Initialize Swiper sliders for the single games page
 */
function initSwipers() {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars -- Storing the instance in a variable to prevent garbage collection
  const lightbox = new Swiper('.single-game__screenshots .swiper-lightbox', {
    modules: [Navigation],
    loop: false,
    spaceBetween: 0,
    slidesPerView: 1,
    slidesPerGroup: 1,
    centeredSlides: true,
    centerInsufficientSlides: true,
    effect: 'fade',
    fadeEffect: {
      crossFade: true,
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    on: {
      /**
       * Ensure video begins to play when the lightbox is opened
       */
      slidesUpdated() {
        this.slides[this.activeIndex]?.querySelector('video')?.play();
      },
      /**
       * Pause all videos when navigating to the previous slide
       */
      navigationPrev() {
        const allVideos = lightboxElement.querySelectorAll('video');
        allVideos.forEach((video) => {
          video.pause();
        });
      },
      /**
       * Pause all videos when navigating to the next slide
       */
      navigationNext() {
        const allVideos = lightboxElement.querySelectorAll('video');
        allVideos.forEach((video) => {
          video.pause();
        });
      },
    },
  });

  /**
   * Initialize Swiper for screenshots carousel
   */
  // eslint-disable-next-line @typescript-eslint/no-unused-vars -- Storing the instance in a variable to prevent garbage collection
  const screenshotsSwiper = new Swiper(screenshotsSliderElement, {
    modules: [Navigation],
    loopAddBlankSlides: false,
    breakpoints: {
      0: {
        loop: true,
        spaceBetween: 10,
        slidesPerView: 'auto',
        slidesPerGroup: 1,
        centeredSlides: true,
      },
      768: {
        loop: true,
        spaceBetween: 10,
        slidesPerView: 2,
        centeredSlides: false,
      },
      1024: {
        loop: false,
        spaceBetween: 20,
        slidesPerView: 3,
        slidesPerGroup: 3,
        centeredSlides: false,
      },
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    /**
     * On click, set the lightbox slider to match the clicked slide
     */
    onAny(eventName) {
      if (eventName === 'click') {
        const offset = this.activeIndex - this.realIndex;
        const totalSlides = this.slides.length;

        // This is required to handle cases where the slider is looped and you click on a negative index.
        let scrollIndex = (this.clickedIndex - offset) % totalSlides;
        if (scrollIndex < 0) {
          scrollIndex += totalSlides;
        }

        lightbox.slideTo(scrollIndex);
      }
    },
  });

  /**
   * Initialize Swiper for related games carousel
   */
  // eslint-disable-next-line @typescript-eslint/no-unused-vars -- Storing the instance in a variable to prevent garbage collection
  const relatedGamesSwiper = new Swiper(relatedGamesSliderElement, {
    breakpoints: {
      0: {
        slidesPerView: 'auto',
        centeredSlides: true,
        loop: true,
        spaceBetween: 15,
      },
      768: {
        slidesPerView: 'auto',
        centeredSlides: false,
        loop: false,
        spaceBetween: 20,
      },
      1024: {
        slidesPerView: 'auto',
        centeredSlides: false,
        loop: false,
        spaceBetween: 33,
      },
    },
  });

  /**
   * Initialize Swiper for related categories carousel
   */
  // eslint-disable-next-line @typescript-eslint/no-unused-vars -- Storing the instance in a variable to prevent garbage collection
  const relatedCategoriesSwiper = new Swiper(relatedCategoriesSliderElement, {
    loopAddBlankSlides: false,
    breakpoints: {
      0: {
        loop: true,
        spaceBetween: 10,
        slidesPerView: 'auto',
        slidesPerGroup: 1,
        centeredSlides: true,
      },
      768: {
        loop: false,
        spaceBetween: 20,
        slidesPerView: 'auto',
        centeredSlides: false,
      },
      1024: {
        loop: false,
        spaceBetween: 30,
        slidesPerView: 3,
        centeredSlides: false,
      },
    },
  });
}

window.addEventListener('DOMContentLoaded', () => {
  initSwipers();

  // Handle opening the lightbox on slider click
  screenshotsSliderElement.addEventListener('click', (event) => {
    if (event.target.closest('.swiper-slide')) {
      body.classList.add('lightbox-open');
    }
  });

  // Handle closing the lightbox on click outside or close button.
  lightboxElement.addEventListener('click', (event) => {
    if (
      event.target.closest('.swiper-slide') ||
      event.target.closest('.swiper-button-next') ||
      event.target.closest('.swiper-button-prev')
    ) {
      return;
    }

    closeLightbox();
  });

  // Handle closing the lightbox on escape key press
  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') {
      return;
    }

    closeLightbox();
  });
});

// Detect when gmae details bar is sticky and add class
document.addEventListener('DOMContentLoaded', () => {
  const gameDetails = document.querySelector('.single-game__details-bar');
  const stickyMarkerElement = document.querySelector('.single-game__details-bar__marker');

  const observer = new IntersectionObserver(
    (entries) => {
      const entry = entries[0];
      if (entry.intersectionRatio === 0) {
        gameDetails.classList.add('single-game__details-bar--is-sticky');
      } else {
        gameDetails.classList.remove('single-game__details-bar--is-sticky');
      }
    },
    {
      root: null,
      threshold: 0.05,
      rootMargin: '-105px 0px 0px 0px',
    },
  );

  observer.observe(stickyMarkerElement);
});
